import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from './locales/en/common.json'
import enAuth from './locales/en/auth.json'
import enNav from './locales/en/nav.json'
import enDashboard from './locales/en/dashboard.json'
import enCatalog from './locales/en/catalog.json'
import enCart from './locales/en/cart.json'
import enProfile from './locales/en/profile.json'
import enCommunity from './locales/en/community.json'

import esCommon from './locales/es/common.json'
import esAuth from './locales/es/auth.json'
import esNav from './locales/es/nav.json'
import esDashboard from './locales/es/dashboard.json'
import esCatalog from './locales/es/catalog.json'
import esCart from './locales/es/cart.json'
import esProfile from './locales/es/profile.json'
import esCommunity from './locales/es/community.json'

import zhCommon from './locales/zh/common.json'
import zhAuth from './locales/zh/auth.json'
import zhNav from './locales/zh/nav.json'
import zhDashboard from './locales/zh/dashboard.json'
import zhCatalog from './locales/zh/catalog.json'
import zhCart from './locales/zh/cart.json'
import zhProfile from './locales/zh/profile.json'
import zhCommunity from './locales/zh/community.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        nav: enNav,
        dashboard: enDashboard,
        catalog: enCatalog,
        cart: enCart,
        profile: enProfile,
        community: enCommunity,
      },
      es: {
        common: esCommon,
        auth: esAuth,
        nav: esNav,
        dashboard: esDashboard,
        catalog: esCatalog,
        cart: esCart,
        profile: esProfile,
        community: esCommunity,
      },
      zh: {
        common: zhCommon,
        auth: zhAuth,
        nav: zhNav,
        dashboard: zhDashboard,
        catalog: zhCatalog,
        cart: zhCart,
        profile: zhProfile,
        community: zhCommunity,
      },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'zh'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
